export const FOREMAN_CATS_SELECT_OPTIONS =
  'CatsHeadtoItem/Counter,CatsHeadtoItem/Workdate,CatsHeadtoItem/Employeenumber,' +
  'CatsHeadtoItem/AbsAttType,CatsHeadtoItem/Catshours,CatsHeadtoItem/Extdocumentno,' +
  'CatsHeadtoItem/Status,CatsHeadtoItem/Statkeyfig,CatsHeadtoItem/Quantity,' +
  'CatsHeadtoItem/Zequipment,CatsHeadtoItem/ZempCreatedBy,CatsHeadtoItem/LongTextstr,' +
  'CatsHeadtoItem/Zrecordtype,CatsHeadtoItem/ZprdGrpID';

export const EMPLOYEE_SELECT_OPTIONS =
  'CCWeek,CostCenter,DAWeek,Default,EmpId,EmpToActivity,FirstName,InvalidDates,LastName,CompanyCode,' +
  'TimeMngtCode,TimeMngtText,WorkScheduleRule,EmpToActivity/ActivityType,EmpToActivity/InvalidDates';

/**@description if you update this string, update the corresponding types. */
export const FOREMAN_CATS_SELECT_OPTIONS_V2 =
  'CatsHeadtoItem/Counter,CatsHeadtoItem/WorkDate,CatsHeadtoItem/EmployeeId,' +
  'CatsHeadtoItem/AbsAttType,CatsHeadtoItem/CatsHours,CatsHeadtoItem/Extdocumentno,' +
  'CatsHeadtoItem/Status,CatsHeadtoItem/SKFId,CatsHeadtoItem/Quantity,' +
  'CatsHeadtoItem/EquipmentId,CatsHeadtoItem/CreatedBy,CatsHeadtoItem/LongTextStr,' +
  'CatsHeadtoItem/RecordType,CatsHeadtoItem/ProdGroupId,CatsHeadtoItem/WBS';

/**@description if you change IGeneralForemanCatsProperties, this string also needs to change. */
export const GENERAL_FOREMAN_CATS_SELECT_OPTIONS_V2 =
  'CatsHeadtoItem/Counter,CatsHeadtoItem/WorkDate,CatsHeadtoItem/EmployeeId,CatsHeadtoItem/AbsAttType,' +
  'CatsHeadtoItem/CatsHours,CatsHeadtoItem/Extdocumentno,CatsHeadtoItem/Status,CatsHeadtoItem/SKFId,' +
  'CatsHeadtoItem/Quantity,CatsHeadtoItem/EquipmentId,CatsHeadtoItem/CreatedBy,CatsHeadtoItem/LongTextStr,' +
  'CatsHeadtoItem/RecordType,CatsHeadtoItem/ProdGroupId,CatsHeadtoItem/ExtBillCode,CatsHeadtoItem/Amount,CatsHeadtoItem/ActivityType,CatsHeadtoItem/WBS, CatsHeadtoItem/WageType';

export const APPROVER_EXTDOCUMENT_SELECT_OPTIONSV2 =
  'DocumentNum, Description, Owner, TaskType, Type, GenericFld01, GenericFld02 ,GenericFld03 ,GenericFld04 ,GenericFld05 ,GenericFld06 ,GenericFld07 , GenericFld08 , GenericFld09 , GenericFld10';
export const EMPLOYEE_SEARCH_SELECT_OPTIONS = 'CostCenter,EmpId,FirstName,LastName,CompanyCode';
export const GF_TIMESHEET_MANAGER_PROJECTS_SELECT_OPTIONSV2 =
  'ProjectId, WBS, ProjDescription, FinishDate, StartDate, TaskType,ProjectToCondition, PriceDescription, PriceGroup, WorkCellId, SoldTo, CustomerDescription, TaskStartDate, TaskFinDate, ProfitCenterDescription';
export const PROJECT_AND_TASKTYPE_START_END_DATES_PROJECTS_V2 = 'FinishDate, StartDate, TaskFinDate, TaskStartDate';

export const SAP_UNAVAILABLE_MESSAGE_PARTIALS = [
  'rfc error: ',
  'dbsql_sql_error',
  'received fatal alert:',
  'gateway timeout error',
  'circuit breaker is enabled as backend is unhealthy',
];
export const SAP_UNAVAILABLE_ERROR_CODES: ReadonlyArray<string> = [
  //DOCS: https://www.sapdatasheet.org/abap/msag//iwfnd/cm_bec.html and https://www.sapdatasheet.org/abap/msag//iwfnd/cm_bec-029.html
  //sample: RFC Error: Runtime error occurred in backend system
  '/IWFND/CM_BEC/029',

  //DOCS: https://www.sapdatasheet.org/abap/msag//iwfnd/cm_bec.html and https://www.sapdatasheet.org/abap/msag//iwfnd/cm_bec-030.html
  //sample: RFC Error: Run 'Connection Test' in sm59 for destination TRUST_PRD for more details
  '/IWFND/CM_BEC/030',

  //Our server converts HTTP codes into error codes if we can't find an SAP error code, so this value will be used when our Angular apps check to see if this is a high severity message or not
  '502',
];
